import { j as n } from "./jsx-runtime-DywqP_6a.js";
import { ChevronUpIcon as yn, ChevronRightIcon as vn, CheckIcon as ft, DotIcon as bn, PlusCircleIcon as he, FileInput as jn, Check as Cn, TableOfContentsIcon as Nn, LockIcon as wn, CircleAlertIcon as Sn, XIcon as gt, Circle as Tn, Unlink2Icon as An, CornerDownRightIcon as On, CornerDownLeftIcon as Pn, DownloadIcon as Rn, UnplugIcon as Ln, SendIcon as $n, CopyIcon as En, IdCardLanyardIcon as In, ShapesIcon as kn, LogInIcon as Dn, CirclePlayIcon as zn } from "lucide-react";
import { r as Fn, u as qn, c as Vn, N as Bn, aL as _n, m as st } from "./chunk-PVWAREVJ-BO6B-RAk.js";
import { c as Le, p as $e, b as xt, a as Un } from "./hook-BkLXq8pm.js";
import { Button as ne } from "./ui/Button.js";
import { d as Mn, f as Gn, I as Hn, j as I, b as Qn } from "./ZudokuContext-BcqSiygJ.js";
import { Z as Jn, i as Wn } from "./invariant-Bm-FVUQE.js";
import * as A from "react";
import { createContext as yt, use as Xn, useRef as R, useEffect as z, useMemo as vt, useState as k, useCallback as bt, Fragment as K, useLayoutEffect as Zn, useTransition as Yn, useContext as Kn } from "react";
import { VisuallyHidden as es } from "@radix-ui/react-visually-hidden";
import { useAuth as ts } from "./zudoku.hooks.js";
import { D as Ee, a as Ie, c as ke, d as jt, e as Ct, g as ns } from "./Dialog-VIMic7xI.js";
import { S as ss, b as rs } from "./index-CVfG8Pb4.js";
import { S as Nt, c as wt, d as St, e as Tt, g as le, A as as, a as os, b as is, u as cs } from "./Select-BiBMWiLv.js";
import { u as ae, b as De, C as F, a as ls, F as ds } from "./index.esm-DpgNxKa2.js";
import { B as E } from "./Button-DTDRi4CT.js";
import * as ze from "@radix-ui/react-collapsible";
import { g as rt, h as at, i as ot, j as us } from "./ErrorAlert-xpVkFS_n.js";
import { c as C } from "./cn-dYga0KKN.js";
import { u as ms } from "./useCopyToClipboard-B_085nfO.js";
import { u as ps } from "./useLatest-hmRS46UF.js";
import * as N from "@radix-ui/react-dropdown-menu";
import * as Oe from "@radix-ui/react-checkbox";
import * as de from "@radix-ui/react-popover";
import { PopoverAnchor as hs } from "@radix-ui/react-popover";
import { P as fs } from "./index-CrcNWbel.js";
import { f as gs, g as xs, C as ys, b as vs } from "./Command-TEBTONf1.js";
import { Input as ue } from "./ui/Input.js";
import { Slot as bs } from "@radix-ui/react-slot";
import { C as js } from "./Card-hTy9PAnh.js";
import * as At from "@radix-ui/react-label";
import { c as Cs } from "./index-DI5SPFK9.js";
import * as se from "@radix-ui/react-radio-group";
import { z as Ns } from "./useExposedProps-B8NHdNRq.js";
import { h as ws } from "./SyntaxHighlight-CPF64UHi.js";
let je;
const Ss = (e) => {
  if (e.errors?.[0])
    throw new Jn(e.errors[0].message, {
      developerHint: "Check your configuration value `apis.type` and `apis.input` in the Zudoku config."
    });
};
class Ts {
  constructor(t) {
    this.config = t;
  }
  #e = async () => (je || (je = import("./createServer-DL1AYSpR.js").then(
    (t) => t.createServer(this.config)
  )), je);
  #t = async (t) => this.config.server ? fetch(this.config.server, t) : (await this.#e()).fetch("http://localhost/graphql", t);
  fetch = async (t, s) => {
    const a = t.match(/query (\w+)/)?.[1], r = await this.#t({
      method: "POST",
      body: JSON.stringify({ query: t, variables: s, operationName: a }),
      headers: { "Content-Type": "application/json" }
    });
    if (!r.ok)
      throw new Error("Network response was not ok");
    const o = await r.json();
    return Ss(o), o.data;
  };
}
function Ce(e, t) {
  if (!!!e)
    throw new Error(t);
}
function As(e) {
  return typeof e == "object" && e !== null;
}
function Os(e, t) {
  if (!!!e)
    throw new Error(
      t ?? "Unexpected invariant triggered."
    );
}
const Ps = /\r\n|[\n\r]/g;
function Pe(e, t) {
  let s = 0, a = 1;
  for (const r of e.body.matchAll(Ps)) {
    if (typeof r.index == "number" || Os(!1), r.index >= t)
      break;
    s = r.index + r[0].length, a += 1;
  }
  return {
    line: a,
    column: t + 1 - s
  };
}
function Rs(e) {
  return Ot(
    e.source,
    Pe(e.source, e.start)
  );
}
function Ot(e, t) {
  const s = e.locationOffset.column - 1, a = "".padStart(s) + e.body, r = t.line - 1, o = e.locationOffset.line - 1, i = t.line + o, l = t.line === 1 ? s : 0, c = t.column + l, u = `${e.name}:${i}:${c}
`, d = a.split(/\r\n|[\n\r]/g), h = d[r];
  if (h.length > 120) {
    const g = Math.floor(c / 80), m = c % 80, y = [];
    for (let v = 0; v < h.length; v += 80)
      y.push(h.slice(v, v + 80));
    return u + it([
      [`${i} |`, y[0]],
      ...y.slice(1, g + 1).map((v) => ["|", v]),
      ["|", "^".padStart(m)],
      ["|", y[g + 1]]
    ]);
  }
  return u + it([
    // Lines specified like this: ["prefix", "string"],
    [`${i - 1} |`, d[r - 1]],
    [`${i} |`, h],
    ["|", "^".padStart(c)],
    [`${i + 1} |`, d[r + 1]]
  ]);
}
function it(e) {
  const t = e.filter(([a, r]) => r !== void 0), s = Math.max(...t.map(([a]) => a.length));
  return t.map(([a, r]) => a.padStart(s) + (r ? " " + r : "")).join(`
`);
}
function Ls(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class Fe extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...s) {
    var a, r, o;
    const { nodes: i, source: l, positions: c, path: u, originalError: d, extensions: h } = Ls(s);
    super(t), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = d ?? void 0, this.nodes = ct(
      Array.isArray(i) ? i : i ? [i] : void 0
    );
    const g = ct(
      (a = this.nodes) === null || a === void 0 ? void 0 : a.map((y) => y.loc).filter((y) => y != null)
    );
    this.source = l ?? (g == null || (r = g[0]) === null || r === void 0 ? void 0 : r.source), this.positions = c ?? g?.map((y) => y.start), this.locations = c && l ? c.map((y) => Pe(l, y)) : g?.map((y) => Pe(y.source, y.start));
    const m = As(
      d?.extensions
    ) ? d?.extensions : void 0;
    this.extensions = (o = h ?? m) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), d != null && d.stack ? Object.defineProperty(this, "stack", {
      value: d.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Fe) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const s of this.nodes)
        s.loc && (t += `

` + Rs(s.loc));
    else if (this.source && this.locations)
      for (const s of this.locations)
        t += `

` + Ot(this.source, s);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function ct(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function L(e, t, s) {
  return new Fe(`Syntax Error: ${s}`, {
    source: e,
    positions: [t]
  });
}
class _a {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, s, a) {
    this.start = t.start, this.end = s.end, this.startToken = t, this.endToken = s, this.source = a;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Pt {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, s, a, r, o, i) {
    this.kind = t, this.start = s, this.end = a, this.line = r, this.column = o, this.value = i, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const $s = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Es = new Set(Object.keys($s));
function Ua(e) {
  const t = e?.kind;
  return typeof t == "string" && Es.has(t);
}
var lt;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(lt || (lt = {}));
function Re(e) {
  return e === 9 || e === 32;
}
function re(e) {
  return e >= 48 && e <= 57;
}
function Rt(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Lt(e) {
  return Rt(e) || e === 95;
}
function Is(e) {
  return Rt(e) || re(e) || e === 95;
}
function ks(e) {
  var t;
  let s = Number.MAX_SAFE_INTEGER, a = null, r = -1;
  for (let i = 0; i < e.length; ++i) {
    var o;
    const l = e[i], c = Ds(l);
    c !== l.length && (a = (o = a) !== null && o !== void 0 ? o : i, r = i, i !== 0 && c < s && (s = c));
  }
  return e.map((i, l) => l === 0 ? i : i.slice(s)).slice(
    (t = a) !== null && t !== void 0 ? t : 0,
    r + 1
  );
}
function Ds(e) {
  let t = 0;
  for (; t < e.length && Re(e.charCodeAt(t)); )
    ++t;
  return t;
}
function zs(e, t) {
  const s = e.replace(/"""/g, '\\"""'), a = s.split(/\r\n|[\n\r]/g), r = a.length === 1, o = a.length > 1 && a.slice(1).every((m) => m.length === 0 || Re(m.charCodeAt(0))), i = s.endsWith('\\"""'), l = e.endsWith('"') && !i, c = e.endsWith("\\"), u = l || c, d = !(t != null && t.minimize) && // add leading and trailing new lines only if it improves readability
  (!r || e.length > 70 || u || o || i);
  let h = "";
  const g = r && Re(e.charCodeAt(0));
  return (d && !g || o) && (h += `
`), h += s, (d || u) && (h += `
`), '"""' + h + '"""';
}
var x;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(x || (x = {}));
class Fs {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const s = new Pt(x.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = s, this.token = s, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== x.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const s = Vs(this, t.end);
          t.next = s, s.prev = t, t = s;
        }
      while (t.kind === x.COMMENT);
    return t;
  }
}
function qs(e) {
  return e === x.BANG || e === x.DOLLAR || e === x.AMP || e === x.PAREN_L || e === x.PAREN_R || e === x.SPREAD || e === x.COLON || e === x.EQUALS || e === x.AT || e === x.BRACKET_L || e === x.BRACKET_R || e === x.BRACE_L || e === x.PIPE || e === x.BRACE_R;
}
function Z(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function fe(e, t) {
  return $t(e.charCodeAt(t)) && Et(e.charCodeAt(t + 1));
}
function $t(e) {
  return e >= 55296 && e <= 56319;
}
function Et(e) {
  return e >= 56320 && e <= 57343;
}
function U(e, t) {
  const s = e.source.body.codePointAt(t);
  if (s === void 0)
    return x.EOF;
  if (s >= 32 && s <= 126) {
    const a = String.fromCodePoint(s);
    return a === '"' ? `'"'` : `"${a}"`;
  }
  return "U+" + s.toString(16).toUpperCase().padStart(4, "0");
}
function w(e, t, s, a, r) {
  const o = e.line, i = 1 + s - e.lineStart;
  return new Pt(t, s, a, o, i, r);
}
function Vs(e, t) {
  const s = e.source.body, a = s.length;
  let r = t;
  for (; r < a; ) {
    const o = s.charCodeAt(r);
    switch (o) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++r;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++r, ++e.line, e.lineStart = r;
        continue;
      case 13:
        s.charCodeAt(r + 1) === 10 ? r += 2 : ++r, ++e.line, e.lineStart = r;
        continue;
      // Comment
      case 35:
        return Bs(e, r);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return w(e, x.BANG, r, r + 1);
      case 36:
        return w(e, x.DOLLAR, r, r + 1);
      case 38:
        return w(e, x.AMP, r, r + 1);
      case 40:
        return w(e, x.PAREN_L, r, r + 1);
      case 41:
        return w(e, x.PAREN_R, r, r + 1);
      case 46:
        if (s.charCodeAt(r + 1) === 46 && s.charCodeAt(r + 2) === 46)
          return w(e, x.SPREAD, r, r + 3);
        break;
      case 58:
        return w(e, x.COLON, r, r + 1);
      case 61:
        return w(e, x.EQUALS, r, r + 1);
      case 64:
        return w(e, x.AT, r, r + 1);
      case 91:
        return w(e, x.BRACKET_L, r, r + 1);
      case 93:
        return w(e, x.BRACKET_R, r, r + 1);
      case 123:
        return w(e, x.BRACE_L, r, r + 1);
      case 124:
        return w(e, x.PIPE, r, r + 1);
      case 125:
        return w(e, x.BRACE_R, r, r + 1);
      // StringValue
      case 34:
        return s.charCodeAt(r + 1) === 34 && s.charCodeAt(r + 2) === 34 ? Qs(e, r) : Us(e, r);
    }
    if (re(o) || o === 45)
      return _s(e, r, o);
    if (Lt(o))
      return Js(e, r);
    throw L(
      e.source,
      r,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Z(o) || fe(s, r) ? `Unexpected character: ${U(e, r)}.` : `Invalid character: ${U(e, r)}.`
    );
  }
  return w(e, x.EOF, a, a);
}
function Bs(e, t) {
  const s = e.source.body, a = s.length;
  let r = t + 1;
  for (; r < a; ) {
    const o = s.charCodeAt(r);
    if (o === 10 || o === 13)
      break;
    if (Z(o))
      ++r;
    else if (fe(s, r))
      r += 2;
    else
      break;
  }
  return w(
    e,
    x.COMMENT,
    t,
    r,
    s.slice(t + 1, r)
  );
}
function _s(e, t, s) {
  const a = e.source.body;
  let r = t, o = s, i = !1;
  if (o === 45 && (o = a.charCodeAt(++r)), o === 48) {
    if (o = a.charCodeAt(++r), re(o))
      throw L(
        e.source,
        r,
        `Invalid number, unexpected digit after 0: ${U(
          e,
          r
        )}.`
      );
  } else
    r = Ne(e, r, o), o = a.charCodeAt(r);
  if (o === 46 && (i = !0, o = a.charCodeAt(++r), r = Ne(e, r, o), o = a.charCodeAt(r)), (o === 69 || o === 101) && (i = !0, o = a.charCodeAt(++r), (o === 43 || o === 45) && (o = a.charCodeAt(++r)), r = Ne(e, r, o), o = a.charCodeAt(r)), o === 46 || Lt(o))
    throw L(
      e.source,
      r,
      `Invalid number, expected digit but got: ${U(
        e,
        r
      )}.`
    );
  return w(
    e,
    i ? x.FLOAT : x.INT,
    t,
    r,
    a.slice(t, r)
  );
}
function Ne(e, t, s) {
  if (!re(s))
    throw L(
      e.source,
      t,
      `Invalid number, expected digit but got: ${U(
        e,
        t
      )}.`
    );
  const a = e.source.body;
  let r = t + 1;
  for (; re(a.charCodeAt(r)); )
    ++r;
  return r;
}
function Us(e, t) {
  const s = e.source.body, a = s.length;
  let r = t + 1, o = r, i = "";
  for (; r < a; ) {
    const l = s.charCodeAt(r);
    if (l === 34)
      return i += s.slice(o, r), w(e, x.STRING, t, r + 1, i);
    if (l === 92) {
      i += s.slice(o, r);
      const c = s.charCodeAt(r + 1) === 117 ? s.charCodeAt(r + 2) === 123 ? Ms(e, r) : Gs(e, r) : Hs(e, r);
      i += c.value, r += c.size, o = r;
      continue;
    }
    if (l === 10 || l === 13)
      break;
    if (Z(l))
      ++r;
    else if (fe(s, r))
      r += 2;
    else
      throw L(
        e.source,
        r,
        `Invalid character within String: ${U(
          e,
          r
        )}.`
      );
  }
  throw L(e.source, r, "Unterminated string.");
}
function Ms(e, t) {
  const s = e.source.body;
  let a = 0, r = 3;
  for (; r < 12; ) {
    const o = s.charCodeAt(t + r++);
    if (o === 125) {
      if (r < 5 || !Z(a))
        break;
      return {
        value: String.fromCodePoint(a),
        size: r
      };
    }
    if (a = a << 4 | ee(o), a < 0)
      break;
  }
  throw L(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${s.slice(
      t,
      t + r
    )}".`
  );
}
function Gs(e, t) {
  const s = e.source.body, a = dt(s, t + 2);
  if (Z(a))
    return {
      value: String.fromCodePoint(a),
      size: 6
    };
  if ($t(a) && s.charCodeAt(t + 6) === 92 && s.charCodeAt(t + 7) === 117) {
    const r = dt(s, t + 8);
    if (Et(r))
      return {
        value: String.fromCodePoint(a, r),
        size: 12
      };
  }
  throw L(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${s.slice(t, t + 6)}".`
  );
}
function dt(e, t) {
  return ee(e.charCodeAt(t)) << 12 | ee(e.charCodeAt(t + 1)) << 8 | ee(e.charCodeAt(t + 2)) << 4 | ee(e.charCodeAt(t + 3));
}
function ee(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function Hs(e, t) {
  const s = e.source.body;
  switch (s.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw L(
    e.source,
    t,
    `Invalid character escape sequence: "${s.slice(
      t,
      t + 2
    )}".`
  );
}
function Qs(e, t) {
  const s = e.source.body, a = s.length;
  let r = e.lineStart, o = t + 3, i = o, l = "";
  const c = [];
  for (; o < a; ) {
    const u = s.charCodeAt(o);
    if (u === 34 && s.charCodeAt(o + 1) === 34 && s.charCodeAt(o + 2) === 34) {
      l += s.slice(i, o), c.push(l);
      const d = w(
        e,
        x.BLOCK_STRING,
        t,
        o + 3,
        // Return a string of the lines joined with U+000A.
        ks(c).join(`
`)
      );
      return e.line += c.length - 1, e.lineStart = r, d;
    }
    if (u === 92 && s.charCodeAt(o + 1) === 34 && s.charCodeAt(o + 2) === 34 && s.charCodeAt(o + 3) === 34) {
      l += s.slice(i, o), i = o + 1, o += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      l += s.slice(i, o), c.push(l), u === 13 && s.charCodeAt(o + 1) === 10 ? o += 2 : ++o, l = "", i = o, r = o;
      continue;
    }
    if (Z(u))
      ++o;
    else if (fe(s, o))
      o += 2;
    else
      throw L(
        e.source,
        o,
        `Invalid character within String: ${U(
          e,
          o
        )}.`
      );
  }
  throw L(e.source, o, "Unterminated string.");
}
function Js(e, t) {
  const s = e.source.body, a = s.length;
  let r = t + 1;
  for (; r < a; ) {
    const o = s.charCodeAt(r);
    if (Is(o))
      ++r;
    else
      break;
  }
  return w(
    e,
    x.NAME,
    t,
    r,
    s.slice(t, r)
  );
}
const Ws = 10, It = 2;
function kt(e) {
  return ge(e, []);
}
function ge(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return Xs(e, t);
    default:
      return String(e);
  }
}
function Xs(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const s = [...t, e];
  if (Zs(e)) {
    const a = e.toJSON();
    if (a !== e)
      return typeof a == "string" ? a : ge(a, s);
  } else if (Array.isArray(e))
    return Ks(e, s);
  return Ys(e, s);
}
function Zs(e) {
  return typeof e.toJSON == "function";
}
function Ys(e, t) {
  const s = Object.entries(e);
  return s.length === 0 ? "{}" : t.length > It ? "[" + er(e) + "]" : "{ " + s.map(
    ([r, o]) => r + ": " + ge(o, t)
  ).join(", ") + " }";
}
function Ks(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > It)
    return "[Array]";
  const s = Math.min(Ws, e.length), a = e.length - s, r = [];
  for (let o = 0; o < s; ++o)
    r.push(ge(e[o], t));
  return a === 1 ? r.push("... 1 more item") : a > 1 && r.push(`... ${a} more items`), "[" + r.join(", ") + "]";
}
function er(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const s = e.constructor.name;
    if (typeof s == "string" && s !== "")
      return s;
  }
  return t;
}
const tr = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", nr = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  tr ? function(t, s) {
    return t instanceof s;
  } : function(t, s) {
    if (t instanceof s)
      return !0;
    if (typeof t == "object" && t !== null) {
      var a;
      const r = s.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (a = t.constructor) === null || a === void 0 ? void 0 : a.name
      );
      if (r === o) {
        const i = kt(t);
        throw new Error(`Cannot use ${r} "${i}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Dt {
  constructor(t, s = "GraphQL request", a = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || Ce(!1, `Body must be a string. Received: ${kt(t)}.`), this.body = t, this.name = s, this.locationOffset = a, this.locationOffset.line > 0 || Ce(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Ce(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function sr(e) {
  return nr(e, Dt);
}
function rr(e) {
  const t = sr(e) ? e : new Dt(e), s = t.body, a = new Fs(t);
  let r = "", o = !1;
  for (; a.advance().kind !== x.EOF; ) {
    const i = a.token, l = i.kind, c = !qs(i.kind);
    o && (c || i.kind === x.SPREAD) && (r += " ");
    const u = s.slice(i.start, i.end);
    l === x.BLOCK_STRING ? r += zs(i.value, {
      minimize: !0
    }) : r += u, o = c;
  }
  return r;
}
const zt = yt(
  void 0
), Ma = ({
  children: e,
  client: t
}) => /* @__PURE__ */ n.jsx(zt.Provider, { value: t, children: e }), Ft = (e, t, ...[s]) => ({
  queryFn: () => e.fetch(t, s),
  queryKey: [rr(t.toString()), s]
}), ar = (e, ...[t]) => {
  const s = Xn(zt);
  if (s === void 0)
    throw new Error("useGraphQL must be used within a GraphQLProvider");
  return Ft(s, e, ...t === void 0 ? [] : [t]);
};
class H extends String {
  __apiType;
  value;
  __meta__;
  constructor(t, s) {
    super(t), this.value = t, this.__meta__ = s;
  }
  toString() {
    return this.value;
  }
}
const or = new H(
  `
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  deprecated
  extensions
  parameters {
    name
    in
    description
    required
    schema
    style
    explode
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}
    `,
  { fragmentName: "OperationsFragment" }
), ir = new H(`
    query ServersQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), cr = new H(`
    query SchemaWarmup($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    openapi
  }
}
    `), lr = new H(`
    query OperationsForTag($input: JSON!, $type: SchemaType!, $tag: String, $untagged: Boolean) {
  schema(input: $input, type: $type) {
    servers {
      url
    }
    description
    summary
    title
    url
    version
    tag(slug: $tag, untagged: $untagged) {
      name
      description
      operations {
        slug
        ...OperationsFragment
      }
      extensions
      next {
        name
        slug
        extensions
      }
      prev {
        name
        slug
        extensions
      }
    }
  }
}
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  deprecated
  extensions
  parameters {
    name
    in
    description
    required
    schema
    style
    explode
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}`), dr = new H(`
    query GetSchemas($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    title
    description
    summary
    components {
      schemas {
        name
        schema
        extensions
      }
    }
  }
}
    `), ur = new H(`
    query getServerQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), mr = new H(`
    query GetNavigationOperations($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    extensions
    tags {
      slug
      name
      extensions
      operations {
        summary
        slug
        method
        operationId
        path
      }
    }
    components {
      schemas {
        __typename
      }
    }
  }
}
    `), pr = {
  "\n  query ServersQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": ir,
  "\n  fragment OperationsFragment on OperationItem {\n    slug\n    summary\n    method\n    description\n    operationId\n    contentTypes\n    path\n    deprecated\n    extensions\n    parameters {\n      name\n      in\n      description\n      required\n      schema\n      style\n      explode\n      examples {\n        name\n        description\n        externalValue\n        value\n        summary\n      }\n    }\n    requestBody {\n      content {\n        mediaType\n        encoding {\n          name\n        }\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        schema\n      }\n      description\n      required\n    }\n    responses {\n      statusCode\n      links\n      description\n      content {\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        mediaType\n        encoding {\n          name\n        }\n        schema\n      }\n    }\n  }\n": or,
  "\n  query SchemaWarmup($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      openapi\n    }\n  }\n": cr,
  "\n  query OperationsForTag(\n    $input: JSON!\n    $type: SchemaType!\n    $tag: String\n    $untagged: Boolean\n  ) {\n    schema(input: $input, type: $type) {\n      servers {\n        url\n      }\n      description\n      summary\n      title\n      url\n      version\n      tag(slug: $tag, untagged: $untagged) {\n        name\n        description\n        operations {\n          slug\n          ...OperationsFragment\n        }\n        extensions\n        next {\n          name\n          slug\n          extensions\n        }\n        prev {\n          name\n          slug\n          extensions\n        }\n      }\n    }\n  }\n": lr,
  "\n  query GetSchemas($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      title\n      description\n      summary\n      components {\n        schemas {\n          name\n          schema\n          extensions\n        }\n      }\n    }\n  }\n": dr,
  "\n  query getServerQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": ur,
  "\n  query GetNavigationOperations($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      extensions\n      tags {\n        slug\n        name\n        extensions\n        operations {\n          summary\n          slug\n          method\n          operationId\n          path\n        }\n      }\n      components {\n        schemas {\n          __typename\n        }\n      }\n    }\n  }\n": mr
};
function hr(e) {
  return pr[e] ?? {};
}
const q = ze.Root, qt = ze.CollapsibleTrigger, V = ze.CollapsibleContent;
function fr() {
  const t = navigator.userAgent.toLowerCase();
  if (t.indexOf("win") !== -1)
    return "windows";
  if (t.indexOf("mac") !== -1)
    return "apple";
  if (t.indexOf("linux") !== -1)
    return "linux";
  if (t.indexOf("x11") !== -1)
    return "unix";
}
function gr() {
  return fr() === "apple";
}
const xr = {
  other: {
    alt: "Alt",
    meta: "Ctrl",
    ctrl: "Ctrl",
    shift: "⇧",
    option: "Alt"
  },
  apple: {
    alt: "⌥",
    meta: "⌘",
    ctrl: "Ctrl",
    shift: "⇧",
    option: "⌥"
  }
}, yr = (e, t) => {
  const s = e.toLowerCase().split("+"), a = s.includes("meta"), r = s.includes("shift"), o = s.includes("option") || s.includes("alt"), i = s.includes("ctrl"), l = e.split("+").pop(), c = R(t);
  return z(() => {
    c.current = t;
  }, [t]), z(() => {
    const u = (d) => {
      (d.code === `Key${l?.toUpperCase()}` || d.code.toLowerCase() === l?.toLowerCase()) && d.metaKey === a && d.shiftKey === r && d.altKey === o && d.ctrlKey === i && (d.preventDefault(), c.current());
    };
    return window.addEventListener("keydown", u), () => {
      window.removeEventListener("keydown", u);
    };
  }, [l, a, r, o, i]), {
    trigger: () => c.current(),
    label: s.map(
      (u) => u === "meta" || u === "ctrl" || u === "alt" || u === "shift" || u === "option" ? xr[gr() ? "apple" : "other"][u] : u
    )
  };
}, vr = Le()(
  $e(
    (e) => ({
      selectedServer: void 0,
      setSelectedServer: (t) => e({ selectedServer: t })
    }),
    { name: "zudoku-selected-server" }
  )
), br = (e) => {
  const { selectedServer: t, setSelectedServer: s } = vr();
  return { selectedServer: vt(
    () => t && e.some((r) => r.url === t) ? t : e.at(0)?.url ?? "",
    [t, e]
  ), setSelectedServer: s };
}, Vt = A.forwardRef(
  ({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
    "textarea",
    {
      className: C(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ref: s,
      ...t
    }
  )
);
Vt.displayName = "Textarea";
const M = ({
  children: e,
  className: t
}) => /* @__PURE__ */ n.jsxs(
  "div",
  {
    className: C(
      "grid grid-cols-[max-content_1fr_min-content_max-content] items-center gap-4 group bg-muted w-full h-10 ps-4 pe-2 border-b",
      t
    ),
    children: [
      e,
      /* @__PURE__ */ n.jsx(
        qt,
        {
          className: C(
            "flex items-center gap-4 group bg-muted w-full p-2 hover:bg-accent hover:brightness-95 rounded-md",
            t
          ),
          children: /* @__PURE__ */ n.jsx(
            yn,
            {
              className: "group-data-[state=open]:rotate-180 transition-transform flex-shrink-0",
              size: 16
            }
          )
        }
      )
    ]
  }
), G = ({
  children: e,
  className: t
}) => /* @__PURE__ */ n.jsx("span", { className: C("font-semibold w-full text-start", t), children: e }), jr = N.Root, Cr = N.Trigger, Nr = N.Group, wr = A.forwardRef(({ className: e, inset: t, children: s, ...a }, r) => /* @__PURE__ */ n.jsxs(
  N.SubTrigger,
  {
    ref: r,
    className: C(
      "flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...a,
    children: [
      s,
      /* @__PURE__ */ n.jsx(vn, { className: "ml-auto h-4 w-4" })
    ]
  }
));
wr.displayName = N.SubTrigger.displayName;
const Sr = A.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  N.SubContent,
  {
    ref: s,
    className: C(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Sr.displayName = N.SubContent.displayName;
const Bt = A.forwardRef(({ className: e, sideOffset: t = 4, ...s }, a) => /* @__PURE__ */ n.jsx(N.Portal, { children: /* @__PURE__ */ n.jsx(
  N.Content,
  {
    ref: a,
    sideOffset: t,
    className: C(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...s
  }
) }));
Bt.displayName = N.Content.displayName;
const _t = A.forwardRef(({ className: e, inset: t, ...s }, a) => /* @__PURE__ */ n.jsx(
  N.Item,
  {
    ref: a,
    className: C(
      "relative flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...s
  }
));
_t.displayName = N.Item.displayName;
const Tr = A.forwardRef(({ className: e, children: t, checked: s, ...a }, r) => /* @__PURE__ */ n.jsxs(
  N.CheckboxItem,
  {
    ref: r,
    className: C(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: s,
    ...a,
    children: [
      /* @__PURE__ */ n.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ n.jsx(N.ItemIndicator, { children: /* @__PURE__ */ n.jsx(ft, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
Tr.displayName = N.CheckboxItem.displayName;
const Ar = A.forwardRef(({ className: e, children: t, ...s }, a) => /* @__PURE__ */ n.jsxs(
  N.RadioItem,
  {
    ref: a,
    className: C(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...s,
    children: [
      /* @__PURE__ */ n.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ n.jsx(N.ItemIndicator, { children: /* @__PURE__ */ n.jsx(bn, { className: "h-4 w-4 fill-current" }) }) }),
      t
    ]
  }
));
Ar.displayName = N.RadioItem.displayName;
const Ut = A.forwardRef(({ className: e, inset: t, ...s }, a) => /* @__PURE__ */ n.jsx(
  N.Label,
  {
    ref: a,
    className: C(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...s
  }
));
Ut.displayName = N.Label.displayName;
const Mt = A.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  N.Separator,
  {
    ref: s,
    className: C("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Mt.displayName = N.Separator.displayName;
const Or = ({
  examples: e,
  onSelect: t
}) => /* @__PURE__ */ n.jsxs(jr, { children: [
  /* @__PURE__ */ n.jsx(Cr, { asChild: !0, children: /* @__PURE__ */ n.jsxs(
    E,
    {
      variant: "ghost",
      size: "sm",
      className: "hover:bg-accent hover:brightness-95",
      children: [
        "Use Example ",
        /* @__PURE__ */ n.jsx(he, { size: 16, className: "ml-2" })
      ]
    }
  ) }),
  /* @__PURE__ */ n.jsx(Bt, { className: "max-w-72", children: e.map((s) => /* @__PURE__ */ n.jsxs("div", { children: [
    /* @__PURE__ */ n.jsx(Ut, { children: s.mediaType }),
    /* @__PURE__ */ n.jsx(Mt, {}),
    /* @__PURE__ */ n.jsx(Nr, { children: s.examples?.map((a) => /* @__PURE__ */ n.jsx(
      _t,
      {
        onSelect: () => t(a, s.mediaType),
        children: /* @__PURE__ */ n.jsx(
          "span",
          {
            className: "line-clamp-1",
            title: a.summary ?? a.name,
            children: a.summary ?? a.name
          }
        )
      },
      a.name
    )) })
  ] }, s.mediaType)) })
] }), Pr = ({ content: e }) => {
  const { register: t, setValue: s, watch: a } = ae(), r = (e ?? []).flatMap((i) => i.examples), o = a("headers");
  return /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
    /* @__PURE__ */ n.jsxs(M, { children: [
      /* @__PURE__ */ n.jsx(jn, { size: 16 }),
      /* @__PURE__ */ n.jsx(G, { children: "Body" }),
      e && r.length > 0 ? /* @__PURE__ */ n.jsx(
        Or,
        {
          examples: e,
          onSelect: (i, l) => {
            s("body", JSON.stringify(i.value, null, 2)), s("headers", [
              ...o.filter((c) => c.name !== "Content-Type"),
              {
                name: "Content-Type",
                value: l,
                active: !0
              }
            ]);
          }
        }
      ) : /* @__PURE__ */ n.jsx("div", {})
    ] }),
    /* @__PURE__ */ n.jsx(V, { className: "flex flex-col gap-2 ", children: /* @__PURE__ */ n.jsx(
      Vt,
      {
        ...t("body"),
        className: C(
          "w-full p-2 h-64 font-mono md:text-xs border-none rounded-none focus-visible:ring-0"
        ),
        placeholder: "Your body here..."
      }
    ) })
  ] });
}, ut = (e, t, s) => {
  const a = t.replace(/(:\w+|\{\w+})/g, (o) => {
    const i = o.replace(/[:{}]/g, "");
    return s.pathParams.find((c) => c.name === i)?.value ?? o;
  }), r = new URL(
    a.replace(/^\//, ""),
    e.endsWith("/") ? e : `${e}/`
  );
  return s.queryParams.filter((o) => o.active).forEach((o) => {
    r.searchParams.set(o.name, o.value);
  }), r;
};
function Rr(e) {
  return /^(application\/octet-stream|image\/|audio\/|video\/|font\/|application\/pdf|application\/zip|application\/x-protobuf|application\/x-binary)/i.test(
    e
  );
}
const Lr = (e, t) => {
  const s = e.find(
    ([a]) => a.toLowerCase() === "content-disposition"
  )?.[1];
  if (s) {
    const a = s.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    if (a?.[1])
      return a[1].replace(/['"]/g, "");
  }
  try {
    const r = new URL(t).pathname.split("/").pop() || "download";
    return r.includes(".") ? r : "download";
  } catch {
    return "download";
  }
}, xe = A.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  Oe.Root,
  {
    ref: s,
    className: C(
      "peer h-4 w-4 shrink-0 rounded-[min(6px,var(--radius)-4px)] ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary",
      "border border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary",
      e
    ),
    ...t,
    children: /* @__PURE__ */ n.jsx(
      Oe.Indicator,
      {
        className: C("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ n.jsx(Cn, { className: "h-4 w-4" })
      }
    )
  }
));
xe.displayName = Oe.Root.displayName;
const $r = de.Root, Gt = A.forwardRef(({ className: e, align: t = "center", sideOffset: s = 4, ...a }, r) => /* @__PURE__ */ n.jsx(de.Portal, { children: /* @__PURE__ */ n.jsx(
  de.Content,
  {
    ref: r,
    align: t,
    sideOffset: s,
    className: C(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...a
  }
) }));
Gt.displayName = de.Content.displayName;
const Er = ({
  value: e,
  options: t,
  onChange: s,
  className: a,
  placeholder: r = "Value",
  onEnterPress: o,
  ref: i
}) => {
  const [l, c] = k(!1), [u, d] = k(!1), h = fs((m) => m.filtered.count), g = R(null);
  return /* @__PURE__ */ n.jsxs($r, { open: l, children: [
    /* @__PURE__ */ n.jsx(hs, { children: /* @__PURE__ */ n.jsx(
      xs,
      {
        autoComplete: "off",
        ref: (m) => {
          g.current = m, typeof i == "function" ? i(m) : i && (i.current = m);
        },
        value: e,
        placeholder: r,
        className: C("h-9 bg-transparent", a),
        onFocus: () => c(!0),
        onBlur: () => {
          u || c(!1);
        },
        onKeyDown: (m) => {
          m.key === "Enter" && (c(!1), g.current?.blur(), o?.(m));
        },
        onValueChange: (m) => s(m)
      }
    ) }),
    /* @__PURE__ */ n.jsx(
      Gt,
      {
        onMouseEnter: () => d(!0),
        onMouseLeave: () => d(!1),
        onOpenAutoFocus: (m) => m.preventDefault(),
        className: C("p-0 w-(--radix-popover-trigger-width)", {
          "border-0": h === 0
        }),
        align: "start",
        side: "bottom",
        onWheel: (m) => {
          m.stopPropagation();
        },
        onTouchMove: (m) => {
          m.stopPropagation();
        },
        children: /* @__PURE__ */ n.jsx(ys, { className: "max-h-[140px]", children: t.map((m) => /* @__PURE__ */ n.jsx(
          vs,
          {
            value: m,
            onSelect: (y) => {
              s(y), c(!1);
            },
            className: "cursor-pointer",
            children: m
          },
          m
        )) })
      }
    )
  ] });
}, me = ({ shouldFilter: e, ...t }) => /* @__PURE__ */ n.jsx(gs, { className: "bg-transparent", shouldFilter: e, children: /* @__PURE__ */ n.jsx(Er, { ...t }) }), oe = (e, t) => {
  const s = A.forwardRef(({ className: a, asChild: r, ...o }, i) => {
    const l = r ? bs : e;
    return A.createElement(l, {
      ...o,
      ref: i,
      className: typeof t == "function" ? t({ className: a }) : C(t, a)
    });
  });
  return s.displayName = `VariantComponent(${e})`, s;
}, qe = oe(
  "div",
  "grid grid-cols-[min-content_2fr_3fr] items-center gap-x-5"
), pe = oe(
  "div",
  "group h-9 hover:bg-accent/75 ps-4 pe-2 grid col-span-full grid-cols-subgrid items-center border-b"
), Ir = Object.freeze([
  "Accept",
  "Accept-Encoding",
  "Accept-Language",
  "Authorization",
  "Cache-Control",
  "Connection",
  "Content-Disposition",
  "Content-Encoding",
  "Content-Language",
  "Content-Length",
  "Content-Range",
  "Content-Security-Policy",
  "Content-Type",
  "Cookie",
  "Date",
  "ETag",
  "Expires",
  "Host",
  "If-Modified-Since",
  "Location",
  "Origin",
  "Pragma",
  "Referer",
  "Set-Cookie",
  "User-Agent",
  "X-Requested-With"
]), kr = ({
  control: e,
  schemaHeaders: t,
  lockedHeaders: s
}) => {
  const { fields: a, append: r, remove: o } = De({
    control: e,
    name: "headers"
  }), { setValue: i, watch: l, formState: c } = ae(), u = R([]), d = R([]), h = l("headers"), g = bt(
    (f) => {
      f?.stopPropagation(), r({ name: "", value: "", active: !1 }, { shouldFocus: !0 });
    },
    [r]
  );
  z(() => {
    h.length === 0 && g();
  }, [h, g]);
  const m = (f) => {
    u.current[f]?.focus();
  }, y = (f) => {
    g(), requestAnimationFrame(() => d.current[f + 1]?.focus());
  }, v = t.filter((f) => !h.some((j) => j.name === f.name)).map(({ name: f }) => f), b = a.flatMap((f, j) => !s?.map((S) => S.toLowerCase()).includes(f.name.toLowerCase()) ? [] : [j]), O = s?.map((f) => ({
    name: f,
    id: `locked-${f}`,
    value: "••••••••••",
    active: !0,
    locked: !0
  })) ?? [];
  return /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
    /* @__PURE__ */ n.jsxs(M, { children: [
      /* @__PURE__ */ n.jsx(Nn, { size: 16 }),
      /* @__PURE__ */ n.jsx(G, { children: "Headers" }),
      /* @__PURE__ */ n.jsxs(
        ne,
        {
          onClick: g,
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "hover:bg-accent hover:brightness-95 flex gap-2",
          children: [
            "Add header ",
            /* @__PURE__ */ n.jsx(he, { size: 16 })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ n.jsx("div", { className: "overflow-hidden", children: /* @__PURE__ */ n.jsxs(qe, { children: [
      O.map((f) => /* @__PURE__ */ n.jsxs(rt, { children: [
        /* @__PURE__ */ n.jsx(at, { asChild: !0, children: /* @__PURE__ */ n.jsxs(
          pe,
          {
            className: "opacity-50 cursor-not-allowed font-mono text-xs min-h-10",
            children: [
              /* @__PURE__ */ n.jsx(wn, { size: 16 }),
              /* @__PURE__ */ n.jsx(
                ue,
                {
                  value: f.name,
                  disabled: !0,
                  className: "w-full border-0 p-0 m-0 shadow-none text-xs focus-visible:ring-0 font-mono"
                }
              ),
              /* @__PURE__ */ n.jsx("div", { children: f.value })
            ]
          },
          f.id
        ) }),
        /* @__PURE__ */ n.jsx(
          ot,
          {
            alignOffset: 10,
            side: "bottom",
            align: "start",
            children: /* @__PURE__ */ n.jsx("p", { children: "This header is set by the selected authentication." })
          }
        )
      ] }, f.id)),
      a.map((f, j) => {
        const $ = t.find(
          (S) => S.name === h.at(j)?.name
        );
        return /* @__PURE__ */ n.jsxs(
          pe,
          {
            className: C(
              b.includes(j) && "text-amber-600",
              b.includes(j) && !c.dirtyFields.headers?.[j]?.value && "hidden"
            ),
            children: [
              /* @__PURE__ */ n.jsx(
                F,
                {
                  control: e,
                  name: `headers.${j}.active`,
                  render: ({ field: S }) => /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
                    /* @__PURE__ */ n.jsx(
                      xe,
                      {
                        id: `headers.${j}.active`,
                        className: C(
                          b.includes(j) && "hidden"
                        ),
                        checked: S.value,
                        onCheckedChange: (D) => {
                          S.onChange(D);
                        }
                      }
                    ),
                    /* @__PURE__ */ n.jsxs(rt, { children: [
                      /* @__PURE__ */ n.jsx(at, { asChild: !0, children: /* @__PURE__ */ n.jsx(
                        Sn,
                        {
                          className: C(
                            "text-amber-600",
                            !b.includes(j) && "hidden"
                          ),
                          size: 16
                        }
                      ) }),
                      /* @__PURE__ */ n.jsx(
                        ot,
                        {
                          alignOffset: 10,
                          side: "bottom",
                          align: "start",
                          children: /* @__PURE__ */ n.jsx("p", { children: "This header will be overwritten by the selected authentication." })
                        }
                      )
                    ] })
                  ] })
                }
              ),
              /* @__PURE__ */ n.jsx(
                F,
                {
                  control: e,
                  name: `headers.${j}.name`,
                  render: ({ field: S }) => /* @__PURE__ */ n.jsx(
                    me,
                    {
                      ...S,
                      placeholder: "Name",
                      className: "border-0 p-0 m-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono",
                      options: [...v, ...Ir],
                      onEnterPress: () => m(j),
                      onChange: (D) => {
                        S.onChange(D), i(`headers.${j}.active`, !0);
                      },
                      ref: (D) => {
                        d.current[j] = D;
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ n.jsx(
                  F,
                  {
                    control: e,
                    name: `headers.${j}.value`,
                    render: ({ field: S }) => $?.enum && $.enum.length > 0 ? /* @__PURE__ */ n.jsx(
                      me,
                      {
                        shouldFilter: !1,
                        value: S.value,
                        options: $.enum ?? [],
                        onChange: (P) => {
                          S.onChange(P), i(`headers.${j}.active`, !0);
                        },
                        className: "border-0 p-0 m-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono"
                      }
                    ) : /* @__PURE__ */ n.jsx(
                      ue,
                      {
                        placeholder: "Value",
                        className: "w-full truncate border-0 p-0 m-0 shadow-none text-xs focus-visible:ring-0 font-mono",
                        autoComplete: "off",
                        ...S,
                        ref: (P) => {
                          u.current[j] = P;
                        },
                        onKeyDown: (P) => {
                          P.key === "Enter" && P.currentTarget.value.trim() && y(j);
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ n.jsx(
                  ne,
                  {
                    size: "icon-xs",
                    variant: "ghost",
                    className: "text-muted-foreground opacity-0 group-hover:brightness-95 group-hover:opacity-100",
                    onClick: () => o(j),
                    type: "button",
                    children: /* @__PURE__ */ n.jsx(gt, { size: 16 })
                  }
                )
              ] })
            ]
          },
          f.id
        );
      })
    ] }) }) }) })
  ] });
}, Dr = Cs(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Ve = A.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  At.Root,
  {
    ref: s,
    className: C(Dr(), e),
    ...t
  }
));
Ve.displayName = At.Root.displayName;
const Ht = A.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  se.Root,
  {
    className: C("grid gap-2", e),
    ...t,
    ref: s
  }
));
Ht.displayName = se.Root.displayName;
const Qt = A.forwardRef(({ className: e, ...t }, s) => /* @__PURE__ */ n.jsx(
  se.Item,
  {
    ref: s,
    className: C(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ n.jsx(se.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ n.jsx(Tn, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
Qt.displayName = se.Item.displayName;
const Jt = ({
  identities: e,
  setValue: t,
  value: s
}) => /* @__PURE__ */ n.jsx("div", { className: "w-full overflow-hidden", children: /* @__PURE__ */ n.jsx(
  Ht,
  {
    onValueChange: (a) => t(a),
    value: s,
    defaultValue: te,
    className: "gap-0",
    disabled: e?.length === 0,
    children: [{ id: te, label: "None" }, ...e ?? []].map(
      (a) => /* @__PURE__ */ n.jsxs(
        Ve,
        {
          className: "h-10 items-center border-b font-normal flex gap-4 p-4 cursor-pointer hover:bg-accent/75",
          children: [
            /* @__PURE__ */ n.jsx(Qt, { value: a.id, id: a.id }),
            /* @__PURE__ */ n.jsx("span", { children: a.label })
          ]
        },
        a.id
      )
    )
  }
) }), zr = ({
  onSubmit: e,
  identities: t,
  open: s,
  onOpenChange: a
}) => {
  const [r, o] = k(void 0), [i, l] = k(!1);
  return /* @__PURE__ */ n.jsx(Ee, { open: s, onOpenChange: a, children: /* @__PURE__ */ n.jsxs(Ie, { children: [
    /* @__PURE__ */ n.jsx(ke, { children: "Select an auth identity" }),
    /* @__PURE__ */ n.jsx(jt, { children: "Please select an identity for this request." }),
    /* @__PURE__ */ n.jsx(js, { className: "max-h-80 overflow-auto", children: /* @__PURE__ */ n.jsx(
      Jt,
      {
        identities: t,
        setValue: o,
        value: r
      }
    ) }),
    /* @__PURE__ */ n.jsxs(Ct, { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ n.jsx(
          xe,
          {
            id: "remember",
            checked: i,
            onCheckedChange: (c) => l(
              c === "indeterminate" ? !1 : !!c
            )
          }
        ),
        /* @__PURE__ */ n.jsx(Ve, { htmlFor: "remember", children: "Remember my choice" })
      ] }),
      /* @__PURE__ */ n.jsx(
        E,
        {
          onClick: () => e({ identity: r, rememberedIdentity: i }),
          children: "Send"
        }
      )
    ] })
  ] }) });
}, we = (e) => Math.abs(
  Number.isNaN(parseInt(e)) ? e.toLowerCase().charCodeAt(0) - 96 : Number.isNaN(parseInt(e)) ? 0 : parseInt(e)
), Se = (e) => e.length > 1 ? parseInt(e.split("").reduce((t, s) => `${we(t) + we(s)}`)) : we(e), mt = (e, t = {}) => {
  const s = (3 * Se(e) + 2 * Se(e) + Se(e)) % 360, { saturation: a = 75, lightness: r = 60 } = t;
  return `${s}deg ${a}% ${r}%`;
}, Te = "data-linked-param", Fr = (e) => {
  const { resolvedTheme: t } = Ns();
  return {
    text: mt(
      e,
      t === "light" ? { saturation: 95, lightness: 38 } : {}
    ),
    background: mt(
      e,
      t === "light" ? { saturation: 85, lightness: 40 } : {}
    )
  };
}, Wt = ({
  name: e,
  className: t,
  slug: s,
  title: a,
  children: r,
  onClick: o
}) => {
  const i = R(null), l = s?.replace(/[{}]/g, ""), c = e.replace(/[{}]/g, ""), { text: u, background: d } = Fr(c), h = `hsl(${u} / 100%)`, g = `hsl(${d} / 10%)`, m = `hsl(${d} / 50%)`;
  return z(() => {
    if (!l || !i.current) return;
    const y = () => {
      document.querySelectorAll(`[${Te}="${l}"]`).forEach((O) => {
        O instanceof HTMLElement && (O.dataset.active = "true");
      });
    }, v = () => {
      document.querySelectorAll(`[${Te}="${l}"]`).forEach((O) => {
        O instanceof HTMLElement && (O.dataset.active = "false");
      });
    }, b = i.current;
    return b.addEventListener("mouseenter", y), b.addEventListener("mouseleave", v), () => {
      b.removeEventListener("mouseenter", y), b.removeEventListener("mouseleave", v);
    };
  }, [l]), // biome-ignore lint/a11y/noStaticElementInteractions: Just passing props through
  // biome-ignore lint/a11y/useKeyWithClickEvents: Just passing props through
  /* @__PURE__ */ n.jsx(
    "span",
    {
      [Te]: l,
      className: C(
        // This may not contain (inline-)flex or (inline-)block otherwise it breaks the browser's full text search
        "relative transition-all duration-100 rounded-lg",
        "border border-(--border-color) p-0.5 text-(--param-color) bg-(--background-color)",
        "data-[active=true]:border-(--param-color) data-[active=true]:shadow-sm data-[active=true]:bottom-px",
        t
      ),
      title: a,
      suppressHydrationWarning: !0,
      ref: i,
      onClick: o,
      style: {
        "--param-color": h,
        "--border-color": m,
        "--background-color": g
      },
      children: r ?? e
    }
  );
}, qr = ({
  control: e,
  url: t
}) => {
  const { fields: s } = De({
    control: e,
    name: "pathParams"
  }), a = [...s].sort(
    (r, o) => t.indexOf(`{${r.name}}`) - t.indexOf(`{${o.name}}`)
  );
  return /* @__PURE__ */ n.jsx("div", { className: "overflow-hidden", children: /* @__PURE__ */ n.jsx(qe, { children: a.map((r, o) => /* @__PURE__ */ n.jsxs(pe, { children: [
    /* @__PURE__ */ n.jsx(
      F,
      {
        control: e,
        name: `pathParams.${o}.name`,
        render: () => /* @__PURE__ */ n.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ n.jsx(
          Wt,
          {
            slug: r.name,
            name: r.name,
            className: "font-mono text-xs px-2"
          }
        ) })
      }
    ),
    /* @__PURE__ */ n.jsx("div", { className: "flex justify-between items-center col-span-2", children: /* @__PURE__ */ n.jsx(
      F,
      {
        control: e,
        name: `pathParams.${o}.value`,
        render: ({ field: i }) => /* @__PURE__ */ n.jsx(
          ue,
          {
            ...i,
            required: !0,
            placeholder: "Value",
            className: "w-full truncate border-0 p-0 m-0 shadow-none text-xs font-mono focus-visible:ring-0"
          }
        )
      }
    ) })
  ] }, r.id)) }) });
}, Vr = oe(
  "input",
  "bg-transparent h-9 font-mono text-xs"
), Br = ({
  control: e,
  schemaQueryParams: t
}) => {
  const { fields: s, remove: a, append: r } = De({
    control: e,
    name: "queryParams"
  }), { setValue: o, getValues: i, watch: l } = ae(), c = l("queryParams");
  z(() => {
    c.length === 0 && r({ name: "", value: "", active: !1 }, { shouldFocus: !0 });
  }, [c, r]);
  const u = t.map(
    (d) => !!d.isRequired
  );
  return /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
    /* @__PURE__ */ n.jsxs(M, { children: [
      /* @__PURE__ */ n.jsx(An, { size: 16 }),
      /* @__PURE__ */ n.jsx(G, { children: "Query Parameters" }),
      /* @__PURE__ */ n.jsxs(
        E,
        {
          onClick: () => {
            o("queryParams", [
              ...i("queryParams"),
              { name: "", value: "", active: !1 }
            ]);
          },
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "hover:bg-accent hover:brightness-95 flex gap-2",
          children: [
            "Add parameter ",
            /* @__PURE__ */ n.jsx(he, { size: 16 })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx("div", { className: "overflow-hidden w-full", children: /* @__PURE__ */ n.jsx(qe, { children: s.map((d, h) => {
      const g = t.find(
        (m) => m.name === c.at(h)?.name
      );
      return /* @__PURE__ */ n.jsxs(pe, { children: [
        /* @__PURE__ */ n.jsx(
          F,
          {
            control: e,
            name: `queryParams.${h}.active`,
            render: ({ field: m }) => /* @__PURE__ */ n.jsx(
              xe,
              {
                id: `queryParams.${h}.active`,
                checked: m.value,
                onCheckedChange: m.onChange
              }
            )
          }
        ),
        /* @__PURE__ */ n.jsx(
          F,
          {
            control: e,
            render: ({ field: m }) => u[h] ? /* @__PURE__ */ n.jsx(Vr, { asChild: !0, children: /* @__PURE__ */ n.jsxs(
              "label",
              {
                className: "flex items-center cursor-pointer gap-1",
                htmlFor: `queryParams.${h}.active`,
                title: u[h] ? "Required field" : void 0,
                children: [
                  m.value,
                  u[h] && /* @__PURE__ */ n.jsx("sup", { children: " *" })
                ]
              }
            ) }) : /* @__PURE__ */ n.jsx(
              me,
              {
                placeholder: "Name",
                value: m.value,
                options: t.map((y) => y.name),
                onChange: (y) => {
                  m.onChange(y);
                },
                className: "border-0 p-0 m-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono"
              }
            ),
            name: `queryParams.${h}.name`
          }
        ),
        /* @__PURE__ */ n.jsxs("div", { className: "flex justify-between items-center", children: [
          /* @__PURE__ */ n.jsx(
            F,
            {
              control: e,
              render: ({ field: m }) => g?.enum && g.enum.length > 0 ? /* @__PURE__ */ n.jsx(
                me,
                {
                  value: m.value,
                  options: g.enum ?? [],
                  onChange: (v) => {
                    m.onChange(v), o(`queryParams.${h}.active`, !0);
                  },
                  className: "border-0 shadow-none focus-visible:ring-0 bg-transparent hover:bg-transparent text-xs font-mono"
                }
              ) : /* @__PURE__ */ n.jsx(
                ue,
                {
                  ...m,
                  onChange: (v) => {
                    m.onChange(v.target.value), v.target.value.length > 0 && o(`queryParams.${h}.active`, !0);
                  },
                  placeholder: "Value",
                  "aria-label": "Query parameter value",
                  className: "w-full border-0 p-0 m-0 shadow-none focus-visible:ring-0 text-xs font-mono"
                }
              ),
              name: `queryParams.${h}.value`
            }
          ),
          /* @__PURE__ */ n.jsx(
            E,
            {
              size: "icon-xs",
              variant: "ghost",
              className: "text-muted-foreground opacity-0 group-hover:brightness-95 group-hover:opacity-100",
              onClick: () => a(h),
              type: "button",
              children: /* @__PURE__ */ n.jsx(gt, { size: 16 })
            }
          )
        ] })
      ] }, d.id);
    }) }) }) })
  ] });
}, _r = ({
  open: e,
  setOpen: t,
  onSignUp: s,
  onLogin: a
}) => /* @__PURE__ */ n.jsx(Ee, { open: e, onOpenChange: t, children: /* @__PURE__ */ n.jsxs(Ie, { children: [
  /* @__PURE__ */ n.jsx(ke, { children: "Welcome to the Playground!" }),
  /* @__PURE__ */ n.jsx(jt, { children: "The Playground is a tool for developers to test and explore our APIs. To use the Playground, you need to login." }),
  /* @__PURE__ */ n.jsxs(Ct, { className: "flex gap-2 sm:justify-between", children: [
    /* @__PURE__ */ n.jsx(E, { type: "button", variant: "ghost", onClick: () => t(!1), children: "Skip" }),
    /* @__PURE__ */ n.jsxs("div", { className: "flex gap-2", children: [
      s && /* @__PURE__ */ n.jsx(E, { type: "button", variant: "outline", onClick: s, children: "Sign Up" }),
      a && /* @__PURE__ */ n.jsx(E, { type: "button", variant: "default", onClick: a, children: "Login" })
    ] })
  ] })
] }) }), Ur = Le()(
  $e(
    (e, t) => ({
      rememberedIdentity: null,
      setRememberedIdentity: (s) => e({ rememberedIdentity: s }),
      getRememberedIdentity: (s) => s.find(
        (a) => a === t().rememberedIdentity
      )
    }),
    {
      name: "identity-storage",
      storage: xt(() => sessionStorage)
    }
  )
), Mr = ({
  path: e,
  renderParam: t
}) => {
  let s = 0;
  return e.split("/").map((a, r, o) => {
    const i = Array.from(a.matchAll(/{([^}]+)}/g)), l = [];
    let c = 0;
    return i.forEach((u) => {
      const [d, h] = u;
      if (!h) return;
      const g = u.index;
      g > c && l.push(
        /* @__PURE__ */ n.jsx(K, { children: a.slice(c, g) }, `text-${c}-${g}`)
      ), l.push(
        /* @__PURE__ */ n.jsx(K, { children: t({ name: h, originalValue: d, index: s++ }) }, `param-${h}`)
      ), c = g + d.length;
    }), c < a.length && l.push(
      /* @__PURE__ */ n.jsx(K, { children: a.slice(c) }, `text-${c}-${a.length}`)
    ), // biome-ignore lint/suspicious/noArrayIndexKey: index should be stable
    /* @__PURE__ */ n.jsxs(K, { children: [
      l,
      r < o.length - 1 && "/",
      /* @__PURE__ */ n.jsx("wbr", {})
    ] }, `${a}-${r}`);
  });
}, Gr = ({ url: e }) => {
  const { watch: t, setFocus: s } = ae(), [a] = t(["pathParams"]);
  return /* @__PURE__ */ n.jsx(
    Mr,
    {
      path: e,
      renderParam: ({ name: r, originalValue: o, index: i }) => {
        const l = a.find(
          (c) => c.name === r
        )?.value;
        return /* @__PURE__ */ n.jsx(
          Wt,
          {
            name: r,
            backgroundOpacity: "0",
            slug: r,
            onClick: () => s(`pathParams.${i}.value`),
            children: l || o
          }
        );
      }
    }
  );
}, Hr = () => {
  const { watch: e } = ae(), s = e("queryParams").filter((a) => a.active && a.name).map((a, r, o) => /* @__PURE__ */ n.jsxs(K, { children: [
    a.name,
    "=",
    encodeURIComponent(a.value).replaceAll("%20", "+"),
    r < o.length - 1 && "&",
    /* @__PURE__ */ n.jsx("wbr", {})
  ] }, a.name));
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    s.length > 0 ? "?" : "",
    s
  ] });
}, Xt = (e = 0) => {
  if (e === 0)
    return "0 B";
  const t = Math.floor(Math.log(e) / Math.log(1e3));
  return `${(e / 1e3 ** t).toFixed(t ? 2 : 0)} ${t ? `${"kMGTPEZY"[t - 1]}B` : "B"}`;
}, Qr = ({ status: e }) => {
  if (!e) return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-gray-500" });
  switch (Number(e.toString().slice(0, 1))) {
    case 2:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-green-500" });
    case 4:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-yellow-400" });
    case 5:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-red-500" });
    default:
      return /* @__PURE__ */ n.jsx("div", { className: "w-2 h-2 rounded-full bg-gray-500" });
  }
}, Jr = () => {
  const e = R(null), t = R(null), s = R(Date.now()), a = R(null), r = bt(() => {
    if (t.current) {
      const o = Date.now() - s.current;
      t.current.nodeValue = o.toFixed();
    }
    a.current = requestAnimationFrame(r);
  }, []);
  return Zn(() => {
    const o = e.current;
    if (!o) return;
    const i = document.createTextNode("0");
    return o.appendChild(i), t.current = i, s.current = Date.now(), a.current = requestAnimationFrame(r), () => {
      a.current && cancelAnimationFrame(a.current), t.current && o.contains(i) && o.removeChild(i);
    };
  }, [r]), /* @__PURE__ */ n.jsx("span", { className: "inline-block text-end w-[3ch]", ref: e });
}, Wr = ({
  status: e,
  time: t,
  size: s,
  isFinished: a,
  progress: r
}) => {
  const o = {
    200: "OK",
    201: "Created",
    202: "Accepted",
    204: "No Content",
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    500: "Internal Server Error"
  };
  return /* @__PURE__ */ n.jsxs("div", { className: "relative flex h-10 text-xs gap-4 px-4 items-center justify-between font-mono border-b", children: [
    /* @__PURE__ */ n.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ n.jsx(Qr, { status: e }),
      " ",
      e ?? "Sending Request...",
      e ? ` ${o[e]}` : ""
    ] }),
    /* @__PURE__ */ n.jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ n.jsxs("div", { children: [
        /* @__PURE__ */ n.jsx("span", { className: "text-muted-foreground", children: "Size" }),
        " ",
        /* @__PURE__ */ n.jsx("span", { className: "inline-block text-end min-w-[5ch]", children: s ? Xt(s) : "- B" })
      ] }),
      /* @__PURE__ */ n.jsxs("div", { children: [
        /* @__PURE__ */ n.jsx("span", { className: "text-muted-foreground", children: "Time" }),
        " ",
        t !== void 0 ? `${t.toFixed(0)}` : /* @__PURE__ */ n.jsx(Jr, {}),
        "ms"
      ] })
    ] }),
    /* @__PURE__ */ n.jsx(
      "div",
      {
        className: "h-full bg-neutral-500/10 absolute left-0 -bottom-0 z-10 transition-all duration-200 ease-in-out",
        style: {
          opacity: a ? 0 : 1,
          width: a ? 0 : `${r * 100}%`
        }
      }
    )
  ] });
};
function Be(e) {
  if (e === null) return "null";
  if (Array.isArray(e)) {
    if (e.length === 0) return "any[]";
    const t = e[0];
    return t === void 0 ? "any[]" : `${Be(t)}[]`;
  }
  return typeof e == "object" ? Xr(e) : typeof e;
}
function Xr(e, t = "") {
  const s = ["{"];
  for (const [a, r] of Object.entries(e)) {
    const o = Be(r);
    s.push(`  ${a}: ${o};`);
  }
  return s.push("}"), s.join(`
`);
}
function Zr(e) {
  return { lines: [`type GeneratedType = ${Be(e)};`] };
}
const Zt = ({
  code: e,
  language: t,
  children: s
}) => {
  const { syntaxHighlighting: a } = Mn().options;
  return Wn(a?.highlighter, "Highlighter not found"), ws(
    a.highlighter,
    e ?? s ?? "",
    t,
    a.themes
  );
};
Zt.displayName = "Highlight";
const Yr = (e) => Object.entries({
  "application/json": "json",
  "text/json": "json",
  "text/html": "html",
  "text/css": "css",
  "text/javascript": "javascript",
  "application/xml": "xml",
  "application/xhtml+xml": "xhtml"
}).find(
  ([s]) => e.includes(s)
)?.[1], Kr = (e) => {
  const t = e.find(([s]) => s.toLowerCase() === "content-type")?.[1] || "";
  return Yr(t);
}, ea = (e) => {
  try {
    return JSON.stringify(JSON.parse(e), null, 2);
  } catch {
    return null;
  }
}, ta = (e) => {
  const t = [
    "Content-Type",
    "Content-Length",
    "Authorization",
    "X-RateLimit-Remaining",
    "X-RateLimit-Limit",
    "Cache-Control",
    "ETag"
  ].map((s) => s.toLowerCase());
  return [...e].sort(([s], [a]) => {
    const r = t.indexOf(s.toLowerCase()), o = t.indexOf(a.toLowerCase());
    return r === o ? 0 : r === -1 ? 1 : o === -1 ? -1 : r - o;
  });
}, Y = 3, Ae = oe(
  "div",
  "grid-cols-subgrid grid border-b col-span-full px-4 py-1.5 font-mono text-xs"
), X = oe("div", "py-1 break-all"), na = ({
  body: e = "",
  headers: t,
  request: s,
  size: a,
  isBinary: r = !1,
  fileName: o,
  blob: i
}) => {
  const l = Kr(t), c = ea(e), u = c || e, [d, h] = k(
    c ? "formatted" : "raw"
  ), g = Gn({
    queryKey: ["types", u],
    queryFn: async () => Zr(JSON.parse(u)),
    enabled: d === "types" && !r
  }), m = () => {
    if (i && o) {
      const v = URL.createObjectURL(i), b = document.createElement("a");
      b.href = v, b.download = o, document.body.appendChild(b), b.click(), document.body.removeChild(b), URL.revokeObjectURL(v);
    }
  }, y = ta([...t]);
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
      /* @__PURE__ */ n.jsxs(M, { children: [
        /* @__PURE__ */ n.jsx(On, { size: 16 }),
        /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Header Request" })
      ] }),
      /* @__PURE__ */ n.jsx(V, { children: /* @__PURE__ */ n.jsx("div", { className: "grid grid-cols-2 gap-x-6 text-sm", children: s.headers.slice(0, Y).map(([v, b]) => /* @__PURE__ */ n.jsxs(Ae, { children: [
        /* @__PURE__ */ n.jsx(X, { children: v }),
        /* @__PURE__ */ n.jsx(X, { children: b })
      ] }, v)) }) })
    ] }),
    /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
      /* @__PURE__ */ n.jsxs(M, { children: [
        /* @__PURE__ */ n.jsx(Pn, { size: 16 }),
        /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Header Response" })
      ] }),
      /* @__PURE__ */ n.jsx(V, { children: /* @__PURE__ */ n.jsxs("div", { className: "grid grid-cols-2 gap-x-6 text-sm", children: [
        y.slice(0, Y).map(([v, b]) => /* @__PURE__ */ n.jsxs(Ae, { children: [
          /* @__PURE__ */ n.jsx(X, { children: v }),
          /* @__PURE__ */ n.jsx(X, { children: b })
        ] }, v)),
        y.length > Y && /* @__PURE__ */ n.jsxs(q, { className: "col-span-full grid-cols-subgrid grid group", children: [
          /* @__PURE__ */ n.jsxs(qt, { className: "data-[state=open]:hidden justify-center col-span-2 text-xs text-muted-foreground hover:text-primary border-b h-8 flex items-center gap-2", children: [
            /* @__PURE__ */ n.jsxs("span", { children: [
              "Show ",
              y.length - Y,
              " more headers"
            ] }),
            /* @__PURE__ */ n.jsx(he, { size: 12, className: "text-muted-foreground" })
          ] }),
          /* @__PURE__ */ n.jsx(V, { className: "col-span-full grid grid-cols-subgrid", children: y.slice(Y).map(([v, b]) => /* @__PURE__ */ n.jsxs(Ae, { children: [
            /* @__PURE__ */ n.jsx(X, { children: v }),
            /* @__PURE__ */ n.jsx(X, { children: b })
          ] }, v)) })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ n.jsx("div", { className: "flex gap-2 justify-between items-center border-b h-10", children: c && !r && /* @__PURE__ */ n.jsx("div", { className: "px-2", children: /* @__PURE__ */ n.jsxs(
      Nt,
      {
        value: d,
        onValueChange: (v) => h(v),
        children: [
          /* @__PURE__ */ n.jsx(wt, { className: "min-w-32 border-none h-8", children: /* @__PURE__ */ n.jsx(St, { placeholder: "View" }) }),
          /* @__PURE__ */ n.jsxs(Tt, { children: [
            /* @__PURE__ */ n.jsx(le, { value: "formatted", children: "Formatted" }),
            /* @__PURE__ */ n.jsx(le, { value: "raw", children: "Raw" }),
            /* @__PURE__ */ n.jsx(le, { value: "types", children: "Types" })
          ] })
        ]
      }
    ) }) }),
    /* @__PURE__ */ n.jsx("div", { children: r ? /* @__PURE__ */ n.jsx("div", { className: "p-4 text-center", children: /* @__PURE__ */ n.jsxs("div", { className: "flex flex-col items-center gap-4", children: [
      /* @__PURE__ */ n.jsx("div", { className: "text-lg font-semibold", children: "Binary Content" }),
      /* @__PURE__ */ n.jsx("div", { className: "text-sm text-muted-foreground", children: "This response contains binary data that cannot be displayed as text." }),
      /* @__PURE__ */ n.jsxs(
        E,
        {
          onClick: m,
          className: "flex items-center gap-2",
          disabled: !i,
          children: [
            /* @__PURE__ */ n.jsx(Rn, { className: "h-4 w-4" }),
            "Download ",
            o || "file",
            " (",
            Xt(a),
            ")"
          ]
        }
      )
    ] }) }) : /* @__PURE__ */ n.jsx("div", { className: "overflow-auto max-w-full p-4 text-xs max-h-[calc(83.333vh-180px)]", children: /* @__PURE__ */ n.jsx(
      Zt,
      {
        language: d === "types" ? "typescript" : d === "raw" ? c ? "plain" : l : "json",
        code: (d === "raw" ? e : d === "types" ? g.data?.lines.join(`
`) : u) ?? ""
      }
    ) }) })
  ] });
}, sa = ({
  queryMutation: e,
  showLongRunningWarning: t,
  onCancel: s,
  tip: a,
  isFinished: r,
  progress: o
}) => /* @__PURE__ */ n.jsxs("div", { className: "overflow-y-auto h-[80vh] bg-muted/50", children: [
  (e.isPending || e.data) && /* @__PURE__ */ n.jsx(
    Wr,
    {
      status: e.data?.status,
      time: e.data?.time,
      size: e.data?.size,
      isFinished: r,
      progress: o
    }
  ),
  e.error ? /* @__PURE__ */ n.jsx("div", { className: "max-w-2/3 mx-auto mt-20", children: /* @__PURE__ */ n.jsxs(as, { children: [
    /* @__PURE__ */ n.jsx(Ln, { size: 24, strokeWidth: 1.5, className: "me-5" }),
    /* @__PURE__ */ n.jsx(os, { children: "Request failed" }),
    /* @__PURE__ */ n.jsx(is, { children: e.error.message || String(e.error) || "Unexpected error" })
  ] }) }) : e.data ? /* @__PURE__ */ n.jsx(
    na,
    {
      request: e.data.request,
      size: e.data.size,
      headers: e.data.headers,
      body: e.data.body,
      isBinary: e.data.isBinary,
      fileName: e.data.fileName,
      blob: e.data.blob
    }
  ) : e.isPending ? /* @__PURE__ */ n.jsx("div", { className: "grid place-items-center h-full", children: /* @__PURE__ */ n.jsxs("div", { className: "flex flex-col gap-2 items-center mt-20", children: [
    /* @__PURE__ */ n.jsx(ss, {}),
    /* @__PURE__ */ n.jsxs(
      "div",
      {
        className: C(
          "opacity-0 pointer-events-none transition-opacity h-20 text-sm text-muted-foreground duration-300 flex flex-col gap-2 items-center",
          t && "opacity-100 pointer-events-auto"
        ),
        children: [
          "Looks like the request is taking longer than expected.",
          /* @__PURE__ */ n.jsx(
            ne,
            {
              type: "button",
              onClick: s,
              size: "sm",
              className: "w-fit",
              variant: "outline",
              children: "Cancel"
            }
          )
        ]
      }
    )
  ] }) }) : /* @__PURE__ */ n.jsx("div", { className: "h-full grid place-items-center", children: /* @__PURE__ */ n.jsxs("div", { className: "flex flex-col gap-4 items-center", children: [
    /* @__PURE__ */ n.jsx(
      $n,
      {
        size: 64,
        className: "text-muted-foreground",
        strokeWidth: 1.2
      }
    ),
    /* @__PURE__ */ n.jsx("span", { className: "text-[16px] font-semibold text-muted-foreground", children: "Send your first request" }),
    a
  ] }) })
] }), ra = Le()(
  $e(
    (e) => ({
      skipLogin: !1,
      setSkipLogin: (t) => e({ skipLogin: t })
    }),
    {
      name: "remember-skip-login",
      storage: xt(() => sessionStorage)
    }
  )
), te = "__none", aa = ({
  server: e,
  servers: t = [],
  url: s,
  method: a,
  headers: r = [],
  queryParams: o = [],
  pathParams: i = [],
  defaultBody: l = "",
  examples: c,
  requiresLogin: u = !1,
  onLogin: d,
  onSignUp: h
}) => {
  const { selectedServer: g, setSelectedServer: m } = br(
    t.map((p) => ({ url: p }))
  ), [y, v] = k(!1), b = Hn(), { setRememberedIdentity: O, getRememberedIdentity: f } = Ur(), [, j] = Yn(), { skipLogin: $, setSkipLogin: S } = ra(), [D, P] = k(!1), Q = R(void 0), Ue = ps(O), Me = R(null), { label: sn } = yr("meta+enter", () => {
    Me.current?.requestSubmit();
  }), Ge = s.match(/\{([^}]+)\}/g)?.map((p) => p.slice(1, -1)) ?? [], He = [...i].sort(
    (p, W) => Ge.indexOf(p.name) - Ge.indexOf(W.name)
  ), { register: rn, control: ie, handleSubmit: Qe, watch: Je, setValue: ye, ...ve } = ls({
    defaultValues: {
      body: l,
      queryParams: o.length > 0 ? o.map((p) => ({
        name: p.name,
        value: p.defaultValue ?? "",
        active: p.defaultActive ?? !1,
        enum: p.enum ?? []
      })) : [
        {
          name: "",
          value: "",
          active: !1,
          enum: []
        }
      ],
      pathParams: He.map((p) => ({
        name: p.name,
        value: p.defaultValue ?? ""
      })),
      headers: r.length > 0 ? r.map((p) => ({
        name: p.name,
        value: p.defaultValue ?? "",
        active: p.defaultActive ?? !1
      })) : [
        {
          name: "",
          value: "",
          active: !1
        }
      ],
      identity: f([
        te,
        ...b.data?.map((p) => p.id) ?? []
      ])
    }
  }), J = Je("identity"), an = vt(
    () => b.data?.find((p) => p.id === J)?.authorizationFields,
    [b.data, J]
  );
  z(() => {
    J && Ue.current(J);
  }, [Ue, J]);
  const B = cs({
    gcTime: 0,
    mutationFn: async (p) => {
      const W = performance.now(), fn = Object.fromEntries([
        ...p.headers.filter((T) => T.name && T.active).map((T) => [T.name, T.value])
      ]), _ = new Request(
        ut(e ?? g, s, p),
        {
          method: a.toUpperCase(),
          headers: fn,
          body: p.body ? p.body : void 0
        }
      );
      p.identity !== te && await b.data?.find((T) => T.id === p.identity)?.authorizeRequest(_);
      const be = setTimeout(
        () => P(!0),
        3210
      );
      Q.current = new AbortController(), Q.current.signal.addEventListener("abort", () => {
        clearTimeout(be);
      });
      try {
        const T = await fetch(_, {
          cache: "no-store",
          signal: Q.current.signal
        });
        clearTimeout(be), P(!1);
        const gn = performance.now() - W, xn = new URL(_.url), Ze = Array.from(T.headers.entries()), Ye = T.headers.get("content-type") || "", Ke = Rr(Ye);
        let ce = "", et, tt;
        Ke ? (et = await T.blob(), tt = Lr(Ze, _.url), ce = `Binary content (${Ye})`) : ce = await T.text();
        const nt = T.headers.get("content-length");
        return {
          status: T.status,
          headers: Ze,
          size: nt ? parseInt(nt) : ce.length,
          body: ce,
          time: gn,
          isBinary: Ke,
          fileName: tt,
          blob: et,
          request: {
            method: _.method.toUpperCase(),
            url: _.url,
            headers: [
              ["Host", xn.host],
              ["User-Agent", "Zudoku Playground"],
              ...Array.from(_.headers.entries())
            ],
            body: p.body ? p.body : void 0
          }
        };
      } catch (T) {
        throw clearTimeout(be), P(!1), T instanceof TypeError ? new Error(
          "The request failed, possibly due to network issues or CORS policy."
        ) : T;
      }
    }
  }), We = B.isPending, [on, cn] = k(!1);
  z(() => {
    const p = setTimeout(() => cn(We), 100);
    return () => clearTimeout(p);
  }, [We]);
  const { isFinished: ln, progress: dn } = rs({ isAnimating: on });
  z(() => () => {
    Q.current?.abort();
  }, []);
  const un = /* @__PURE__ */ n.jsx("div", { className: "inline-block opacity-50 hover:opacity-100 transition", children: e ? /* @__PURE__ */ n.jsx("span", { children: e.replace(/^https?:\/\//, "").replace(/\/$/, "") }) : t.length > 1 && /* @__PURE__ */ n.jsxs(
    Nt,
    {
      onValueChange: (p) => {
        j(() => m(p));
      },
      value: g,
      defaultValue: g,
      children: [
        /* @__PURE__ */ n.jsx(wt, { className: "p-0 border-none flex-row-reverse bg-transparent text-xs gap-0.5 h-auto translate-y-[4px]", children: /* @__PURE__ */ n.jsx(St, {}) }),
        /* @__PURE__ */ n.jsx(Tt, { children: t.map((p) => /* @__PURE__ */ n.jsx(le, { value: p, children: p.replace(/^https?:\/\//, "").replace(/\/$/, "") }, p)) })
      ]
    }
  ) }), mn = u && !$, pn = ["POST", "PUT", "PATCH", "DELETE"].includes(
    a.toUpperCase()
  ), [Xe, hn] = ms();
  return /* @__PURE__ */ n.jsx(
    ds,
    {
      register: rn,
      control: ie,
      handleSubmit: Qe,
      watch: Je,
      setValue: ye,
      ...ve,
      children: /* @__PURE__ */ n.jsx(us, { delayDuration: 150, children: /* @__PURE__ */ n.jsxs(
        "form",
        {
          ref: Me,
          onSubmit: Qe((p) => {
            b.data?.length === 0 || p.identity ? B.mutate(p) : v(!0);
          }),
          className: "relative",
          children: [
            /* @__PURE__ */ n.jsx(
              zr,
              {
                identities: b.data ?? [],
                open: y,
                onOpenChange: v,
                onSubmit: ({ rememberedIdentity: p, identity: W }) => {
                  p && ye("identity", W ?? te), v(!1), B.mutate({ ...ve.getValues(), identity: W });
                }
              }
            ),
            /* @__PURE__ */ n.jsx(
              _r,
              {
                open: mn,
                setOpen: (p) => S(!p),
                onSignUp: h,
                onLogin: d
              }
            ),
            /* @__PURE__ */ n.jsxs("div", { className: "grid grid-cols-[1fr_1px_1fr] text-sm", children: [
              /* @__PURE__ */ n.jsxs("div", { className: "col-span-3 p-4 border-b flex gap-2 items-stretch", children: [
                /* @__PURE__ */ n.jsxs("div", { className: "flex flex-1 items-center w-full border rounded-md relative overflow-hidden", children: [
                  /* @__PURE__ */ n.jsx("div", { className: "border-r p-2 bg-muted rounded-l-md self-stretch font-semibold font-mono flex items-center", children: a.toUpperCase() }),
                  /* @__PURE__ */ n.jsx("div", { className: "items-center px-2 font-mono text-xs break-all leading-6 relative h-full w-full", children: /* @__PURE__ */ n.jsxs("div", { className: "h-full py-1.5", children: [
                    un,
                    /* @__PURE__ */ n.jsx(Gr, { url: s }),
                    /* @__PURE__ */ n.jsx(Hr, {})
                  ] }) }),
                  /* @__PURE__ */ n.jsx("div", { className: "px-1", children: /* @__PURE__ */ n.jsx(
                    E,
                    {
                      type: "button",
                      onClick: () => {
                        hn(
                          ut(
                            e ?? g,
                            s,
                            ve.getValues()
                          ).toString()
                        );
                      },
                      variant: "ghost",
                      size: "icon-xs",
                      className: C(
                        "hover:opacity-100 transition",
                        Xe ? "text-emerald-600 opacity-100" : "opacity-50"
                      ),
                      children: Xe ? /* @__PURE__ */ n.jsx(ft, { className: "text-green-500", size: 14 }) : /* @__PURE__ */ n.jsx(En, { size: 14 })
                    }
                  ) })
                ] }),
                /* @__PURE__ */ n.jsx(
                  E,
                  {
                    type: "submit",
                    variant: B.isPending ? "destructive" : "default",
                    onClick: (p) => {
                      B.isPending && (Q.current?.abort(
                        "Request cancelled by user"
                      ), p.preventDefault());
                    },
                    className: "w-18",
                    children: B.isPending ? "Cancel" : "Send"
                  }
                )
              ] }),
              /* @__PURE__ */ n.jsxs("div", { className: "relative overflow-y-auto h-[80vh]", children: [
                b.data?.length !== 0 && /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
                  /* @__PURE__ */ n.jsxs(M, { children: [
                    /* @__PURE__ */ n.jsx(In, { size: 16 }),
                    /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Authentication" })
                  ] }),
                  /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx(
                    Jt,
                    {
                      value: J,
                      identities: b.data ?? [],
                      setValue: (p) => ye("identity", p)
                    }
                  ) })
                ] }),
                He.length > 0 && /* @__PURE__ */ n.jsxs(q, { defaultOpen: !0, children: [
                  /* @__PURE__ */ n.jsxs(M, { children: [
                    /* @__PURE__ */ n.jsx(kn, { size: 16 }),
                    /* @__PURE__ */ n.jsx(G, { className: "col-span-2", children: "Path Parameters" })
                  ] }),
                  /* @__PURE__ */ n.jsx(V, { className: "CollapsibleContent", children: /* @__PURE__ */ n.jsx(qr, { url: s, control: ie }) })
                ] }),
                /* @__PURE__ */ n.jsx(Br, { control: ie, schemaQueryParams: o }),
                /* @__PURE__ */ n.jsx(
                  kr,
                  {
                    control: ie,
                    schemaHeaders: r,
                    lockedHeaders: an?.headers
                  }
                ),
                pn && /* @__PURE__ */ n.jsx(Pr, { content: c })
              ] }),
              /* @__PURE__ */ n.jsx("div", { className: "w-full bg-muted-foreground/20" }),
              /* @__PURE__ */ n.jsx(
                sa,
                {
                  queryMutation: B,
                  showLongRunningWarning: D,
                  isFinished: ln,
                  progress: dn,
                  tip: /* @__PURE__ */ n.jsx("div", { className: "text-xs w-full", children: /* @__PURE__ */ n.jsxs("span", { className: "text-muted-foreground", children: [
                    "Press",
                    " ",
                    /* @__PURE__ */ n.jsx("kbd", { className: "text-foreground border rounded m-0.5 px-1 py-0.5 capitalize", children: sn.join(" + ") }),
                    " ",
                    "to send a request"
                  ] }) }),
                  onCancel: () => {
                    Q.current?.abort(
                      "Request cancelled by the user"
                    ), P(!1);
                  }
                }
              )
            ] })
          ]
        }
      ) })
    }
  );
}, oa = ({
  className: e,
  size: t = 16
}) => /* @__PURE__ */ n.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: e,
    width: t,
    height: t,
    children: /* @__PURE__ */ n.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
        clipRule: "evenodd"
      }
    )
  }
), ia = (e) => {
  const [t, s] = k(!1), { isAuthEnabled: a, login: r, signup: o, isPending: i, isAuthenticated: l } = ts();
  return /* @__PURE__ */ n.jsxs(Ee, { onOpenChange: (c) => s(c), children: [
    /* @__PURE__ */ n.jsx(ns, { asChild: !0, children: e.children ?? /* @__PURE__ */ n.jsxs(
      "button",
      {
        type: "button",
        className: "flex gap-1 items-center px-2 py-1 rounded-md transition text-xs bg-primary  text-primary-foreground shadow-xs hover:bg-primary/80",
        children: [
          "Test",
          /* @__PURE__ */ n.jsx(oa, { size: 14 })
        ]
      }
    ) }),
    /* @__PURE__ */ n.jsxs(
      Ie,
      {
        className: "max-w-screen-xl w-full overflow-hidden p-0",
        "aria-describedby": void 0,
        showCloseButton: !0,
        children: [
          /* @__PURE__ */ n.jsx(es, { children: /* @__PURE__ */ n.jsx(ke, { children: "Playground" }) }),
          t && /* @__PURE__ */ n.jsx(
            aa,
            {
              requiresLogin: a && !l && !i,
              onLogin: () => r(),
              onSignUp: () => o(),
              ...e
            }
          )
        ]
      }
    )
  ] });
}, ca = {
  get: "green",
  post: "blue",
  put: "yellow",
  delete: "red",
  patch: "purple",
  options: "gray",
  head: "gray"
}, pt = ({
  label: e,
  path: t,
  operations: s,
  collapsible: a,
  collapsed: r
}) => ({
  type: "category",
  label: e,
  link: {
    type: "doc",
    path: t,
    file: t,
    label: e
  },
  collapsible: a,
  collapsed: r,
  items: s.map((o) => ({
    type: "link",
    label: o.summary ?? o.path,
    to: `${t}#${o.slug}`,
    badge: {
      label: o.method,
      // biome-ignore lint/style/noNonNullAssertion: is guaranteed to be defined
      color: ca[o.method.toLowerCase()],
      invert: !0
    }
  }))
}), Yt = yt(
  void 0
), Ga = Yt.Provider, la = () => {
  const e = Kn(Yt);
  if (!e)
    throw new Error("useOasConfig must be used within a OasConfigProvider");
  return e.config;
}, ht = (e) => ({
  path: e.routePath,
  async lazy() {
    const { OasProvider: t } = await import("./OasProvider-DH82Y-KM.js");
    return {
      element: /* @__PURE__ */ n.jsx(
        t,
        {
          basePath: e.basePath,
          version: e.version,
          client: e.client,
          config: e.config
        }
      )
    };
  },
  children: e.routes
}), Kt = ({
  path: e,
  tag: t,
  untagged: s
}) => ({
  path: e,
  async lazy() {
    const { OperationList: a } = await import("./OperationList-Dr87uHqG.js");
    return { element: /* @__PURE__ */ n.jsx(a, { tag: t, untagged: s }) };
  }
}), da = ({
  render: e,
  path: t
}) => {
  const { type: s, input: a } = la(), { tag: r } = qn(), o = Vn(), i = ar(nn, { type: s, input: a }), {
    data: { schema: l }
  } = Qn(i), c = l.tags.at(0);
  return !r && c?.slug ? /* @__PURE__ */ n.jsx(
    Bn,
    {
      to: {
        pathname: _n(t, { tag: c.slug }),
        search: o.search
      }
    }
  ) : r && l.tags.some((u) => u.slug === r) ? e(r) : null;
}, ua = ({ path: e }) => ({
  path: e,
  async lazy() {
    const { OperationList: t } = await import("./OperationList-Dr87uHqG.js");
    return {
      element: /* @__PURE__ */ n.jsx(
        da,
        {
          path: e,
          render: (s) => /* @__PURE__ */ n.jsx(t, { tag: s })
        }
      )
    };
  }
}), en = (e) => [
  // Category without tagged operations
  Kt({
    path: I(e, _e),
    untagged: !0
  }),
  // Schema list route
  {
    path: I(e, "~schemas"),
    lazy: async () => {
      const { SchemaList: t } = await import("./SchemaList-07lprC0m.js");
      return { element: /* @__PURE__ */ n.jsx(t, {}) };
    }
  }
], ma = (e, t) => {
  const s = I(e, t.at(0) ?? _e);
  return [
    // Redirect to first tag on the index route
    { index: !0, loader: () => Fn(s) },
    // Create routes for each tag
    ...t.map(
      (a) => Kt({
        path: I(e, a),
        tag: a
      })
    ),
    ...en(e)
  ];
}, tn = (e) => e.type === "file" ? Object.keys(e.input) : [], pa = ({
  basePath: e,
  config: t,
  client: s
}) => {
  const a = t.tagPages;
  if (!a)
    return [
      ht({
        basePath: e,
        routePath: e,
        routes: [
          ua({ path: `${e}/:tag?` }),
          ...en(e)
        ],
        client: s,
        config: t
      })
    ];
  const r = tn(t);
  return (r.length > 1 ? [void 0, ...r] : [void 0]).map((i) => {
    const l = I(e, i);
    return ht({
      basePath: e,
      version: i,
      routePath: l,
      routes: ma(l, a),
      client: s,
      config: t
    });
  });
}, nn = hr(`
  query GetNavigationOperations($input: JSON!, $type: SchemaType!) {
    schema(input: $input, type: $type) {
      extensions
      tags {
        slug
        name
        extensions
        operations {
          summary
          slug
          method
          operationId
          path
        }
      }
      components {
        schemas {
          __typename
        }
      }
    }
  }
`), _e = "~endpoints", Ha = (e) => {
  const t = I(e.path), s = new Ts(e);
  return {
    getHead: () => {
      if (e.type === "url" && !e.skipPreload)
        return /* @__PURE__ */ n.jsx(
          "link",
          {
            rel: "preload",
            href: e.input,
            as: "fetch",
            crossOrigin: "anonymous"
          }
        );
      if (e.server)
        return /* @__PURE__ */ n.jsx("link", { rel: "preconnect", href: e.server });
    },
    getMdxComponents: () => ({
      OpenPlaygroundButton: ({
        requireAuth: a,
        server: r,
        method: o,
        url: i,
        children: l,
        ...c
      }) => {
        const u = Un();
        if (!r)
          throw new Error("Server is required");
        return a && !u.isAuthenticated ? /* @__PURE__ */ n.jsxs(
          ne,
          {
            className: "gap-2 items-center",
            variant: "outline",
            onClick: u.login,
            children: [
              "Login to open in Playground ",
              /* @__PURE__ */ n.jsx(Dn, { size: 16 })
            ]
          }
        ) : /* @__PURE__ */ n.jsx(
          ia,
          {
            url: i ?? "/",
            method: o ?? "get",
            server: r,
            ...c,
            children: /* @__PURE__ */ n.jsx(ne, { className: "gap-2 items-center", variant: "outline", children: l ?? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
              "Open in Playground ",
              /* @__PURE__ */ n.jsx(zn, { size: 16 })
            ] }) })
          }
        );
      }
    }),
    getNavigation: async (a, r) => {
      if (!st({ path: t, end: !1 }, a))
        return [];
      const o = st(
        { path: `${t}/:version?/:tag`, end: !0 },
        a
      );
      try {
        const i = o?.params.version, l = i ?? tn(e).at(0), { type: c } = e, u = c === "file" ? e.input[l] : e.input, d = Ft(s, nn, {
          type: c,
          input: u
        }), h = await r.queryClient.ensureQueryData(d), g = new Map(
          h.schema.tags.filter((f) => f.name && f.operations.length > 0).map((f) => {
            if (!f.name)
              throw new Error(`Tag ${f.slug} has no name`);
            const j = I(t, i, f.slug), $ = f.extensions?.["x-zudoku-collapsed"] ?? !e.options?.expandAllTags, S = f.extensions?.["x-zudoku-collapsible"] ?? !0;
            return [
              f.name,
              pt({
                label: f.extensions?.["x-displayName"] ?? f.name,
                path: j,
                operations: f.operations,
                collapsed: $,
                collapsible: S
              })
            ];
          })
        ), m = h.schema.extensions?.["x-tagGroups"] ?? [], y = new Set(
          m.flatMap(
            (f) => f.tags.filter((j) => g.has(j))
          )
        ), b = [
          ...m.flatMap(
            (f) => {
              const j = f.tags.map(($) => g.get($)).filter(Boolean);
              return j.length === 0 ? [] : [
                {
                  type: "category",
                  label: f.name,
                  items: j,
                  collapsible: !0,
                  collapsed: !e.options?.expandAllTags
                }
              ];
            }
          ),
          ...Array.from(g.entries()).filter(([f]) => !y.has(f)).map(([, f]) => f)
        ], O = h.schema.tags.find(
          (f) => !f.name
        )?.operations;
        return O && b.push(
          pt({
            label: b.length === 0 ? "Endpoints" : "Other endpoints",
            path: I(t, i, _e),
            operations: O,
            collapsed: !e.options?.expandAllTags
          })
        ), h.schema.components?.schemas?.length && b.push({
          type: "link",
          label: "Schemas",
          to: I(t, i, "~schemas")
        }), b;
      } catch {
        return [];
      }
    },
    getRoutes: () => pa({ basePath: t, config: e, client: s })
  };
};
export {
  q as C,
  Ma as G,
  Fs as L,
  Ga as O,
  ia as P,
  $s as Q,
  Dt as S,
  x as T,
  _e as U,
  ar as a,
  qt as b,
  V as c,
  tn as d,
  br as e,
  Wt as f,
  hr as g,
  Mr as h,
  sr as i,
  lt as j,
  _a as k,
  qs as l,
  Fe as m,
  kt as n,
  As as o,
  nr as p,
  Ce as q,
  Os as r,
  L as s,
  Ua as t,
  la as u,
  zs as v,
  Is as w,
  Lt as x,
  nn as y,
  Ha as z
};
//# sourceMappingURL=index-DQ8kWcE8.js.map
